export default [
    {
        name: 'checks.all',
        path: '/checks',
        component: () => import("@/views/modules/checking/pages/check/List.vue")
    },
    {
        name: 'checks.check.lines',
        path: '/checks/:shipment/lines',
        component: () => import("@/views/modules/checking/pages/check/ListItems.vue"),
    }
]
